import { logOut, useCredentialsStore } from '../Store/userStore.ts'
import { Api } from './__generated__/Api.ts'
export const apiClient = new Api({
    baseURL: import.meta.env.VITE_API_URL,
    // headers: { 'Access-Control-Allow-Origin': import.meta.env.VITE_API_URL }  // don`t do it. Header only for response headers only
})
// import initMok from './mok'
// initMok(apiClient.instance)

const REFRESH_URL = '/api/jwt/refresh/'

apiClient.instance.interceptors.request.use(
    config => {
        return config
    },
    async error => {
        return Promise.reject(error)
    }
)
let refreshPromise: Promise<string> | null = null
apiClient.instance.interceptors.response.use(undefined, async error => {
    if (error.status !== 401) return Promise.reject(error)
    if (error.config.url === REFRESH_URL) {
        logOut()
        return
    }
    const originalRequest = error.config
    if (originalRequest._retry) {
        logOut()
        return Promise.reject(error)
    }
    originalRequest._retry = true
    const refreshToken = useCredentialsStore.getState().refreshToken
    if (!refreshToken) {
        logOut()
        return Promise.reject(error)
    }
    try {
        if (!refreshPromise) {
            useCredentialsStore.setState({ loading: true, token: null })
            refreshPromise = apiClient.api
                .jwtRefreshCreate({ refresh: refreshToken })
                .then(({ data }) => {
                    if (!data.access) throw new Error('No access token returned')
                    useCredentialsStore.setState(s => ({ ...s, token: data.access, loading: false }))
                    return data.access
                })
                .catch(error => {
                    logOut()
                    throw error
                })
                .finally(() => {
                    refreshPromise = null
                })
        }

        const newAccessToken = await refreshPromise
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`

        return await apiClient.instance(originalRequest)
    } catch (err) {
        if (err.status === 401) return logOut()
        return Promise.reject(err)
    }
})
